<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "WaMasterPhoneNumberAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  